import { connect } from 'react-redux';
import TicketHeader from './components/TicketHeader';
import TicketsDatagrid from './components/TicketsDatagrid';

const UserMyTicketsPage = () => {
  return (
    <div>
      <TicketHeader />
      <TicketsDatagrid />
    </div>
  );
};

const mapStateToProps = (state) => ({ tickets: state.tickets });

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(UserMyTicketsPage);
